import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'
import { SystemSS } from '../../components/SystemSS'

export const ButtleFlowStep4 = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <section>
            <div className='flex justify-center '>
                <img
                    className=''
                    alt='gameflow button'
                    src={`${process.env.PUBLIC_URL}/images/system/system-step4-fr.webp`}
                />
            </div>{' '}
            <div className='flex justify-center mt-12'>
                <img
                    className=''
                    alt='One more'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-lift-throw-fr.webp`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5 mx-auto mt-12'>
                <p className=' '>
                    <span className='text-pborange'>Soulevez</span> un objet présent sur la carte pour vous en équiper. Vous pouvez également <span className='text-pborange'>voler</span> des objets
                    que portent les ennemis, et <span className='text-pborange'>soulever les ennemis eux-mêmes pour vous en équiper</span> ! Vous pouvez aussi
                    lancer les objets que vous avez soulevés. Vous pouvez même lancer votre arme sur des alliés sans
                    équipement, qui pourront alors s'en équiper ! Vous pouvez aussi lancer des ennemis hors de la carte,
                    ou <span className='text-pborange'>Hors Zone</span>, ce qui leur infligera des dégâts !
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 1,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description="Lancez une arme puissante à un allié se battant à main nues, permettant ainsi à plusieurs alliés de l'utiliser ! Laissez libre cours à votre créativité pour chercher des moyens inventifs d'utiliser cette action !"
                />{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 2,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description="Si vous équipez un allié d'un personnage ennemi que vous avez soulevé, il ne pourra pas agir, et votre personnage l'utilisera comme bouclier s'il est attaqué. C'est un bon moyen de faire d'une pierre deux coups !"
                />{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 3,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description="Si vous lancez un ennemi soulevé hors de la carte, il sera Hors Zone. C'est un excellent moyen de mettre de la distance entre des alliés et l'ennemi, mais aussi d'infliger des dégâts."
                />{' '}
                <div className='flex justify-center mt-12'>
                    <img
                        className=''
                        alt='One more'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-confire-fr.webp`}
                    />
                </div>{' '}
                <p className='mt-8'>
                    Abricot peut invoquer des choses comme les Robotonos, les Tank à pois et les Fantôballons. C'est ce
                    qu'on appelle des <span className='text-pborange'> Gadgets</span>. Si vous combinez un fantôme allié à un gadget, vous pourrez utiliser les
                     <span className='text-pborange'> capacités uniques</span> de ce gadget pour attaquer.
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 4,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='Si Abricot utilise Largage de Gadgets, puis que Marona combine un allié...'
                />{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 5,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                />{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 6,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description="...une puissante unité sera générée ! Utilisez des capacités auxquelles seuls les gadgets ont accès afin de progresser dans l'aventure !"
                />{' '}
                <div className='flex justify-center mt-12'>
                    <img
                        className=''
                        alt='One more'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-confriend-fr.webp`}
                    />
                </div>{' '}
                <p className='mt-8'>
                    <span className='text-pborange'>Marona peut se combiner à des fantômes</span> avec lesquels elle a formé des liens solides. C'est ce qu'on
                    appelle le <span className='text-pborange'>Fantôcombinage</span> !
                </p>{' '}
                <p className=' '>
                    En plus de bénéficier de meilleurs statistiques grâce au fantôcombinage, Marona pourra également
                    utiliser des <span className='text-pborange'>techniques spéciales</span> ! Comme si cela ne suffisait pas, si vous renforcez les liens de
                    Marona, elle pourra attaquer <span className='text-pborange'>ENCORE</span> ! Exécutez des attaques consécutives pour conférer à Marona des
                    <span className='text-pborange'> bonus de plus en plus puissants</span> !
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 7,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description="Plus le lien de Marona avec un allié sera fort, plus vous pourrez utiliser d'attaques consécutives grâce au Fantôcombinage !"
                />{' '}
                <p className=' '>
                    Il est possible de renforcer les liens en parlant aux alliés dans votre base, ou en les déployant
                    lors des combats. Vous pouvez aussi leur offrir des cadeaux !
                </p>{' '}
                <p className=' '>
                    En utilisant Fantôcombinage, vous aurez accès à des techniques super puissantes, ce qui vous
                    permettra de transformer en victoire une situation difficile !
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 8,
                        },
                        {
                            modalId: 'flow-4',
                            index: 9,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description="Éliminez l'ennemi grâce à de fabuleuses et puissantes techniques de Fantôcombinage !"
                />{' '}
                <p className=' '>Utilisez toutes sortes d'attaques pour vaincre vos adversaires !</p>{' '}
            </div>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={9}
            />
        </section>
    )
}
